import { Component, OnInit } from "@angular/core";
import { BigmlFieldDTO } from "@DTOS";

@Component({
    templateUrl: "./tipo-deepnet-configuracion-modal.component.html",
    styleUrls: ["./tipo-deepnet-configuracion-modal.component.scss"]
})
export class TipoDeepnetConfiguracionModalComponent implements OnInit {
    public campo: BigmlFieldDTO = new BigmlFieldDTO();

    constructor() { }

    ngOnInit(): void {
    }

}
